import * as Container from "../scenes/Pages/container"

export default {
  home: {
    path: '/',
    component: Container.Search,
    exact: true,
  },
  InterviewsList: {
    path: '/brand/essentials/interviews',
    exact: true,
    component: Container.Interviews,
  },
  bookmarks: {
    path: '/bookmarks',
    exact: true,
    component: Container.Bookmarks,
  },
  bookmarks: {
    path: '/bookmarks/:slug',
    exactPath: '/bookmarks',
    viewed: '/bookmarks/viewed',
    saved: '/bookmarks/saved',
    component: Container.Bookmarks,
  },
  catalog: {
    path: '/catalog/watches',
    exact: true,
    component: Container.Catalog,
  },
  product: {
    path: '/catalog/models/:slug',
    component: Container.Product,
  },
  charity: {
    path: '/brand/charity',
    component: Container.CharityCatalog,
    exact: true,
  },
  charityContact: {
    path: '/brand/charity/contact',
    component: Container.CharityForm,
    exact: true,
  },
  charityPage: {
    path: '/brand/charity/:slug',
    component: Container.Product,
  },
  brand: {
    path: '/brand',
    component: Container.Catalog,
    exact: true,
  },
  brandPages: {
    path: '/brand/:slug',
    component: Container.Product,
  },
  social: {
    path: '/social-media/:filter?',
    exactPath: '/social-media',
    component: Container.SocialMedia,
    exact: true,
  },
  publications: {
    path: '/news',
    component: Container.Publication,
    exact: true,
  },
  article: {
    path: '/news/:slug',
    component: Container.Article,
  },
  gifts: {
    path: '/challenge/gifts',
    component: Container.Gift,
    exact: true,
  },
  hubQuizz: {
    path: '/challenge/quizz',
    component: Container.HubQuizz,
    exact: true,
  },
  quizz: {
    path: '/challenge/quizz/:slug?',
    exactPath: '/challenge/quizz',
    component: Container.Quizz,
  },
  currentQuizz: {
    path: '/challenge/quizz/current',
    component: Container.Quizz,
  },
  ranking: {
    path: '/challenge/ranking/:filter?',
    exactPath: '/challenge/ranking',
    component: Container.Ranking,
  },
  information: {
    path: '/user/information',
    component: Container.User,
    exact: true,
  },
  stock: {
    path: '/user/stocks',
    component: Container.Stock,
    exact: true,
  },
  team: {
    path: '/user/team/:filter?',
    exactPath: '/user/team',
    component: Container.Team,
  },
  event: {
    path: '/user/agenda/event',
    component: Container.Agenda,
    exact: true,
  },
  // tradeshow: {
  //   path: '/user/agenda/tradeshow',
  //   component: Container.Agenda,
  //   exact: true,
  // },
  counterfeits: {
    path: '/user/alerts',
    component: Container.Counterfeits,
    exact: true,
  },
  counterfeit: {
    path: '/user/alerts/counterfeits/:slug',
    component: Container.Counterfeit,
  },
  thefts: {
    path: '/user/alerts/thefts',
    component: Container.Thefts,
    exact: true,
  },
  theft: {
    path: '/user/alerts/thefts/:slug',
    component: Container.Theft,
  },
  faqs: {
    path: '/q-and-a',
    component: Container.Faq,
    exact: true,
  },
  report: {
    path: '/user/alerts/thefts/report',
    component: Container.Report,
    exact: true,
  },
  challenge: {
    path: '/user/challenge',
    component: Container.Challenge,
    exact: true,
  },
  sitemap: {
    path: '/sitemap',
    component: Container.Sitemap,
    exact: true,
  },
  contact: {
    path: '/contact',
    component: Container.Contact,
    exact: true,
  },
  privacy: {
    path: '/privacy',
    component: Container.Privacy,
    exact: true,
  },
  legals: {
    path: '/legal-info',
    component: Container.Legals,
    exact: true,
  },
  models: {
    path: '/catalog/models',
    component: Container.Catalog,
    exact: true,
  },
  // class: {
  //   path: '/class/:slug',
  //   exact: true,
  //   component: Container.Catalog,
  // },
  friends: {
    path: '/catalog/friends-and-partners',
    exact: true,
    component: Container.Catalog,
  },
  materials: {
    path: '/catalog/materials',
    exact: true,
    component: Container.Catalog,
  },
  complications: {
    path: '/catalog/complications',
    exact: true,
    component: Container.Catalog,
  },
  friendsProduct: {
    path: '/catalog/friends-and-partners/:slug',
    component: Container.Product,
  },
  materialsProduct: {
    path: '/catalog/materials/:slug',
    component: Container.Product,
  },
  complicationsProduct: {
    path: '/catalog/complications/:slug',
    component: Container.Product,
  },
  videos: {
    path: '/training/videos/:slug',
    component: Container.Training,
  },
  inDepth: {
    path: '/catalog/in-depth',
    exact: true,
    component: Container.InDepth,
  },
  inDepthChild: {
    path: '/catalog/in-depth/:slug',
    component: Container.Product,
  },
  catalogEventsList: {
    path: '/catalog/events',
    exact: true,
    component: Container.CatalogEvent,
  },
  catalogEvent: {
    path: '/catalog/events/:slug',
    component: Container.Product,
  },
}



// WEBPACK FOOTER //
// ./src/services/Router.js